import axios from "axios";
import swal from "sweetalert2";
import ApiUrl from "../Constant/baseUrl";
import SecureLS from "secure-ls";

export default class Usersession {
  constructor() {
    this.getBaseUrl = new ApiUrl();
  }

  async getusersession() {
    var ls = new SecureLS();
    let jwttoken = ls.get("key1").jwtToken;
    let routepage;

    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === ""
    ) {
      routepage = "/";
    } else if (window.location.hostname === "giftadmin.mufinpay.com") {
      routepage = "https://giftadmin.mufinpay.com";
    }
    let useruuid = ls.get("key1").uuid;
    let sessionToken = ls.get("key1").sessionToken;
    let data = {
      uuid: useruuid,
      sessionToken: sessionToken,
    };
    // console.log("send session data-------->", data)

    await axios({
      method: "POST",
      url: `${this.getBaseUrl.ApiBAseURL}/api/admin/getSession`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + jwttoken,
        "X-Frame-Options": "sameorigin",
      },
      data: data,
    })
      .then((response) => {
        // console.log("get user sesssion-------> : ", response.data);
        let _res = response.data;

        if (_res.successCode === "SESSION_ACTIVE") {
          //  swal.fire("")
          // console.log("--------->session active")
        } else if (_res.exception === "SESSION_EXPIRED") {
          swal
            .fire({
              title: "Your session has been expired.",
              type: "warning",
              text: "Please login again !!",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "JWT_FORMATE_INVALID") {
          swal
            .fire({
              type: "warning",
              title: "JWT format is not valid",
              text: "Please login again !!",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "SESSION_NOT_FOUND") {
          swal
            .fire({
              type: "warning",
              title: "Your session is not found",
              text: "Please login again !!",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "FIELD_CAN_NOT_BE_EMPTY") {
          swal
            .fire({
              type: "warning",
              title: "Field can not be empty",
              text: "Please login again !!",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "JWT_NOT_VALID") {
          swal
            .fire({
              type: "warning",
              title: "JWT is not valid",
              text: "Please login again !!",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "USER_NOT_FOUND") {
          swal
            .fire({
              type: "warning",
              title: "User does not exist on system",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "JWT_EXPIRED") {
          swal
            .fire({
              type: "warning",
              title: "Your jwt token has been expired",
              text: "Please login again !",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "JWT_MISSING") {
          swal
            .fire({
              type: "warning",
              title: "Authentication Token Missing",
              text: "Access Denied!",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "SESSION_DEAD") {
          swal
            .fire({
              type: "warning",
              title: "You are logged out",
              text: "Please login again !!",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        } else if (_res.exception === "IDEAL_SESSION_EXPIRED") {
          swal
            .fire({
              title: "You have been idle for 15 minutes",
              type: "warning",
              text: "Please login again !!",
              confirmButtonText: "Login",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then(() => {
              ls.removeAll();
              localStorage.clear();
              window.location = routepage;
              // this.props.history.push("/");
            });
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }
}
